import axios from "axios";
import { API_URL } from "../config";
import { user } from "./actions_helper";
import { CURRENT_USER, SET_USERS } from "./types";

/**
 * Fetch all users
 */
export function fetchUsers() {
    return (dispatch: IDispatch<any>) => {
        axios
            .get(`${API_URL}/users.json`, { headers: { authorization: user().token } })
            .then((response) => {
                dispatch({
                    payload: response.data,
                    type: SET_USERS,
                });
            });
    };
}

export function setCurrentUser() {
    return (dispatch: IDispatch<any>) => {
        axios.get(API_URL, { headers: { authorization: user().token } }).then((response) => {
            dispatch({
                payload: response.data,
                type: CURRENT_USER,
            });
        });
    };
}

export interface IMeResponse {
    id: number;
    email: string;
    username: string;
    display_name: string;
    mail_signature: string;
}

export interface IUpdateMePayload {
    display_name?: string;
    mail_signature?: string;
}

export async function fetchMe(): Promise<IMeResponse> {
    const response = await axios.get(`${API_URL}/me.json`, {
        headers: { authorization: user().token },
    });
    return response.data;
}

export async function updateMe(payload: IUpdateMePayload): Promise<IMeResponse> {
    const response = await axios.patch(`${API_URL}/me.json`, payload, {
        headers: { authorization: user().token },
    });
    return response.data;
}
